document.addEventListener('DOMContentLoaded', function () {
  var buttons = document.querySelectorAll('#rlxDial button');
  if (!buttons.length) return;

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      buttons.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');

      var tintVar = btn.dataset.tint;
      var tintSoftVar = btn.dataset.tintSoft;
      var tint = 'var(' + tintVar + ')';
      var tintSoft = 'var(' + tintSoftVar + ')';

      btn.style.setProperty('--tint', tint);

      var title = document.getElementById('rlxHeroTitle');
      var sub = document.getElementById('rlxHeroSub');
      var tag = document.getElementById('rlxHeroTag');
      var visual = document.getElementById('rlxHeroVisual');
      var img = document.getElementById('rlxHeroImg');
      var emojiEl = document.getElementById('rlxHeroEmoji');
      var name = document.getElementById('rlxHeroName');
      var price = document.getElementById('rlxHeroPrice');
      var old = document.getElementById('rlxHeroOld');

      title.textContent = btn.dataset.title || title.textContent;
      title.style.color = tint;
      sub.textContent = btn.dataset.sub || sub.textContent;

      tag.textContent = btn.dataset.tag || 'Trending';
      tag.style.background = tintSoft;
      tag.style.color = tint;

      visual.style.background = tintSoft;

      if (btn.dataset.image) {
        img.src = btn.dataset.image;
        img.style.display = 'block';
        emojiEl.style.display = 'none';
      } else {
        img.style.display = 'none';
        emojiEl.style.display = 'block';
        emojiEl.textContent = btn.dataset.emoji || '';
      }

      name.textContent = btn.dataset.name || 'Coming soon';
      price.textContent = btn.dataset.price || '';
      old.textContent = btn.dataset.compare || '';

      var card = document.getElementById('rlxHeroCard');
      if (btn.dataset.url) {
        card.setAttribute('href', btn.dataset.url);
        card.style.cursor = 'pointer';
      } else {
        card.setAttribute('href', '#');
        card.style.cursor = 'default';
      }
    });
  });
});